
// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import Sidebar from "../Sidebar";
// import "./CityWiseLead.css";
// import API_BASE_URL from "./.././../config/env";

// interface CityStats {
//   id: number;
//   city: string;
//   zone: string;
//   total: number;
//   active: number;
//   invalid: number;
//   not_q: number;
//   site_visit: number;
//   f2f: number;
//   scheduled: number;
//   token_done: number;
//   transactions: number;
// }

// interface CardsData {
//   user_count: number;
//   total_lead: number;
//   scheduled: number;
//   f2f_count: number;
//   site_visit_count: number;
//   token_done_count: number;
//   transaction_done_count: number;
//   invalid_count: number;
// }

// interface FiltersData {
//   filter_type: string;
//   from_date: string | null;
//   to_date: string | null;
// }

// interface ApiResponse {
//   status: string;
//   filters: FiltersData;
//   cards: CardsData;
//   city_wise_data: CityStats[];
// }

// interface GPCUser {
//   id: number;
//   name: string;
//   email: string;
//   mobile_number: string | null;
//   role_id: number;
//   reporting_manager_id: number;
// }

// interface GPCUsersResponse {
//   status: string;
//   data: GPCUser[];
//   parent_user: number;
//   total: number;
//   message: string;
// }

// type FilterType = 'daily' | 'weekly' | 'monthly' | 'quarterly' | 'yearly' | 'overall';

// // Get today's date in YYYY-MM-DD format
// const getTodayDate = (): string => {
//   return new Date().toISOString().split('T')[0];
// };

// // Get date X days ago
// const getDateDaysAgo = (days: number): string => {
//   const date = new Date();
//   date.setDate(date.getDate() - days);
//   return date.toISOString().split('T')[0];
// };

// // Get date X months ago
// const getDateMonthsAgo = (months: number): string => {
//   const date = new Date();
//   date.setMonth(date.getMonth() - months);
//   return date.toISOString().split('T')[0];
// };

// // Get date X years ago
// const getDateYearsAgo = (years: number): string => {
//   const date = new Date();
//   date.setFullYear(date.getFullYear() - years);
//   return date.toISOString().split('T')[0];
// };

// const CityWiseLead: React.FC = () => {
//   const navigate = useNavigate();
//   const [selectedPartner, setSelectedPartner] = useState<string>("");
//   const [selectedReportingUser, setSelectedReportingUser] = useState<string>("");
//   const [searchTerm, setSearchTerm] = useState<string>("");
//   const [reportingSearchTerm, setReportingSearchTerm] = useState<string>("");
//   const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
//   const [isReportingDropdownOpen, setIsReportingDropdownOpen] = useState<boolean>(false);
//   const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState<string | null>(null);
//   const [apiData, setApiData] = useState<ApiResponse | null>(null);
//   const [gpcUsers, setGpcUsers] = useState<GPCUser[]>([]);
//   const [reportingUsers, setReportingUsers] = useState<GPCUser[]>([]);
//   const [parentUserId, setParentUserId] = useState<string>("");
//   const [loadingUsers, setLoadingUsers] = useState(false);
//   const [loadingReportingUsers, setLoadingReportingUsers] = useState(false);
//   const dropdownRef = useRef<HTMLDivElement>(null);
//   const reportingDropdownRef = useRef<HTMLDivElement>(null);
//   const token = localStorage.getItem("authToken");

//   // Date filter states
//   const [filterType, setFilterType] = useState<FilterType>('overall');
//   const [fromDate, setFromDate] = useState<string>("");
//   const [toDate, setToDate] = useState<string>("");
//   const [isCustomDate, setIsCustomDate] = useState<boolean>(false);

//   // Get filter type label
//   const getFilterTypeLabel = (type: FilterType): string => {
//     const labels: Record<FilterType, string> = {
//       daily: 'Daily',
//       weekly: 'Weekly',
//       monthly: 'Monthly',
//       quarterly: 'Quarterly',
//       yearly: 'Yearly',
//       overall: 'Overall'
//     };
//     return labels[type] || 'Overall';
//   };

//   // Get date range based on filter type
//   const getDateRangeForFilterType = (type: FilterType): { fromDate: string; toDate: string } => {
//     const today = getTodayDate();

//     switch (type) {
//       case 'daily':
//         return { fromDate: today, toDate: today };
//       case 'weekly':
//         return { fromDate: getDateDaysAgo(7), toDate: today };
//       case 'monthly':
//         return { fromDate: getDateMonthsAgo(1), toDate: today };
//       case 'quarterly':
//         return { fromDate: getDateMonthsAgo(3), toDate: today };
//       case 'yearly':
//         return { fromDate: getDateYearsAgo(1), toDate: today };
//       case 'overall':
//       default:
//         return { fromDate: '', toDate: '' };
//     }
//   };

//   // Handle filter type change
//   const handleFilterTypeChange = (type: FilterType) => {
//     setFilterType(type);
//     setIsCustomDate(false);

//     if (type === 'overall') {
//       setFromDate('');
//       setToDate('');
//     } else {
//       const { fromDate, toDate } = getDateRangeForFilterType(type);
//       setFromDate(fromDate);
//       setToDate(toDate);
//     }

//     // Auto-submit when filter type changes
//     const userId = selectedReportingUser || selectedPartner || parentUserId;
//     if (userId) {
//       const { fromDate, toDate } = type === 'overall' 
//         ? { fromDate: '', toDate: '' } 
//         : getDateRangeForFilterType(type);
      
//       setTimeout(() => {
//         fetchCityWiseData(userId, fromDate, toDate, type);
//       }, 100);
//     }
//   };

//   useEffect(() => {
//     // Set default filter to overall
//     setFilterType('overall');
//     setFromDate('');
//     setToDate('');

//     // Fetch GPC users and parent_user
//     fetchGPCUsers();
//   }, []);

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event: MouseEvent) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
//         setIsDropdownOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // Close reporting dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event: MouseEvent) => {
//       if (reportingDropdownRef.current && !reportingDropdownRef.current.contains(event.target as Node)) {
//         setIsReportingDropdownOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // Fetch city-wise data with user_id parameter, date filters, and filter type
//   const fetchCityWiseData = async (
//     userId: string, 
//     fromDateParam?: string, 
//     toDateParam?: string,
//     filterTypeParam?: FilterType
//   ) => {
//     if (!userId) {
//       console.warn("No user ID provided");
//       setLoading(false);
//       return;
//     }

//     setLoading(true);
//     setError(null);

//     // Build URL with query parameters
//     let url = `${API_BASE_URL}/api/partner-count/leads/city-wise-data/${userId}`;
//     const params = new URLSearchParams();
    
//     // Add filter type if provided
//     if (filterTypeParam) {
//       params.append('filter_type', filterTypeParam);
//     }
    
//     // Add date filters if provided
//     if (fromDateParam) {
//       params.append('from_date', fromDateParam);
//     }
//     if (toDateParam) {
//       params.append('to_date', toDateParam);
//     }
    
//     if (params.toString()) {
//       url += `?${params.toString()}`;
//     }

//     try {
//       console.log("Fetching city-wise data from:", url);

//       const response = await axios.get(
//         url,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//             "Accept": "application/json",
//           },
//           timeout: 30000,
//         }
//       );

//       console.log("API Response:", response.data);

//       if (response.data.status === "success") {
//         setApiData(response.data);
//       } else {
//         setError(response.data.message || "Failed to fetch data");
//       }
//     } catch (err: any) {
//       console.error("Error fetching city-wise data:", err);
      
//       let errorMessage = "Failed to fetch city-wise data";
      
//       if (err.response) {
//         if (err.response.status === 404) {
//           errorMessage = `API endpoint not found. Please check the URL: ${url}`;
//         } else if (err.response.status === 401) {
//           errorMessage = "Unauthorized. Please login again.";
//         } else if (err.response.status === 403) {
//           errorMessage = "You don't have permission to access this data.";
//         } else {
//           errorMessage = err.response.data?.message || err.response.data?.error || errorMessage;
//         }
//       } else if (err.request) {
//         errorMessage = "No response from server. Please check your internet connection.";
//       } else {
//         errorMessage = err.message || errorMessage;
//       }
      
//       setError(errorMessage);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchGPCUsers = async () => {
//     if (!token) {
//       console.warn("No token found for fetching GPC users");
//       setError("User not authenticated. Please login again.");
//       setLoading(false);
//       return;
//     }

//     setLoadingUsers(true);
//     try {
//       const response = await axios.get(
//         `${API_BASE_URL}/api/partner-count/gpc-users-over-target`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//             "Accept": "application/json",
//           },
//           timeout: 15000,
//         }
//       );

//       console.log("GPC Users Response:", response.data);

//       if (response.data.status === "success" && response.data.data) {
//         const users = response.data.data;
//         const parentUser = response.data.parent_user || 1161;
        
//         setGpcUsers(users);
//         setParentUserId(String(parentUser));
        
//         console.log("Parent User ID:", parentUser);
//         console.log("Total Users:", users.length);
        
//         // Set search term to empty (no pre-selection)
//         setSearchTerm('');
        
//         // Fetch reporting users for parent_user
//         await fetchReportingUsers(String(parentUser));
        
//         // Fetch overall data for parent_user
//         fetchCityWiseData(String(parentUser), '', '', 'overall');
//       } else {
//         console.warn("Failed to fetch GPC users:", response.data.message);
//         setError(response.data.message || "Failed to fetch users");
//         setLoading(false);
//       }
//     } catch (err: any) {
//       console.error("Error fetching GPC users:", err);
      
//       let errorMessage = "Failed to fetch users";
//       if (err.response) {
//         errorMessage = err.response.data?.message || err.response.data?.error || errorMessage;
//         if (err.response.status === 401) {
//           errorMessage = "Unauthorized. Please login again.";
//         }
//       } else if (err.request) {
//         errorMessage = "No response from server. Please check your internet connection.";
//       }
//       setError(errorMessage);
//       setLoading(false);
//     } finally {
//       setLoadingUsers(false);
//     }
//   };

//   // Fetch reporting users for selected partner or parent_user
//   const fetchReportingUsers = async (userId: string) => {
//     if (!userId) {
//       console.warn("No user ID provided for fetching reporting users");
//       setReportingUsers([]);
//       setSelectedReportingUser("");
//       setReportingSearchTerm("");
//       return;
//     }

//     console.log("Fetching reporting users for targetUserId:", userId);
//     setLoadingReportingUsers(true);
    
//     try {
//       const url = `${API_BASE_URL}/api/partner-count/gpc-users-over-target?targetUserId=${userId}`;
//       console.log("Fetching reporting users from:", url);

//       const response = await axios.get(
//         url,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//             "Accept": "application/json",
//           },
//           timeout: 15000,
//         }
//       );

//       console.log("Reporting Users Response Data:", response.data);

//       if (response.data.status === "success" && response.data.data && response.data.data.length > 0) {
//         console.log(`Found ${response.data.data.length} reporting users`);
//         console.log("Reporting Users List:", response.data.data);
        
//         const users = response.data.data;
//         setReportingUsers(users);
//         // Do NOT pre-select any reporting user
//         setSelectedReportingUser("");
//         setReportingSearchTerm("");
//       } else {
//         console.log("No reporting users found for this user");
//         setReportingUsers([]);
//         setSelectedReportingUser("");
//         setReportingSearchTerm("");
//       }
//     } catch (err: any) {
//       console.error("Error fetching reporting users:", err);
      
//       let errorMessage = "Failed to fetch reporting users";
      
//       if (err.response) {
//         if (err.response.status === 404) {
//           errorMessage = "API endpoint not found. Please check the URL.";
//         } else if (err.response.status === 401) {
//           errorMessage = "Unauthorized. Please login again.";
//         } else if (err.response.status === 403) {
//           errorMessage = "You don't have permission to access this data.";
//         } else if (err.response.status === 500) {
//           errorMessage = "Server error. Please try again later.";
//         } else {
//           errorMessage = err.response.data?.message || errorMessage;
//         }
//       } else if (err.message && err.message.includes('CORS')) {
//         errorMessage = "CORS error: Please contact administrator to enable CORS for this API.";
//       } else if (err.request) {
//         errorMessage = "No response from server. Please check your internet connection.";
//       } else {
//         errorMessage = err.message || errorMessage;
//       }
      
//       setError(errorMessage);
//       setReportingUsers([]);
//       setSelectedReportingUser("");
//       setReportingSearchTerm("");
//     } finally {
//       setLoadingReportingUsers(false);
//     }
//   };

//   // Handle partner selection
//   const handlePartnerSelect = (userId: string, userName: string) => {
//     console.log("Partner selected with ID:", userId, "Name:", userName);
//     setSelectedPartner(userId);
//     setSearchTerm(userName);
//     setIsDropdownOpen(false);
    
//     // Reset reporting users
//     setReportingUsers([]);
//     setSelectedReportingUser("");
//     setReportingSearchTerm("");
    
//     // Fetch reporting users for the selected partner
//     fetchReportingUsers(userId);
    
//     // Fetch data for selected partner with current filter
//     fetchCityWiseData(userId, fromDate, toDate, filterType);
//   };

//   // Handle reporting user selection
//   const handleReportingUserSelect = (userId: string, userName: string) => {
//     console.log("Reporting user selected:", userId, userName);
//     setSelectedReportingUser(userId);
//     setReportingSearchTerm(userName);
//     setIsReportingDropdownOpen(false);
//     // Fetch city-wise data with the selected reporting user
//     fetchCityWiseData(userId, fromDate, toDate, filterType);
//   };

//   // Handle search input change
//   const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     setSearchTerm(e.target.value);
//     setIsDropdownOpen(true);
//     // If search is cleared, reset selection
//     if (!e.target.value.trim()) {
//       setSelectedPartner("");
//       // Reset reporting users
//       setReportingUsers([]);
//       setSelectedReportingUser("");
//       setReportingSearchTerm("");
//       // Show parent_user data again
//       if (parentUserId) {
//         fetchCityWiseData(parentUserId, fromDate, toDate, filterType);
//         // Also fetch reporting users for parent_user
//         fetchReportingUsers(parentUserId);
//       }
//     }
//   };

//   // Handle reporting search input change
//   const handleReportingSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     setReportingSearchTerm(e.target.value);
//     setIsReportingDropdownOpen(true);
//     // If search is cleared, reset selection
//     if (!e.target.value.trim()) {
//       setSelectedReportingUser("");
//     }
//   };

//   // Handle date filter submit
//   const handleDateFilterSubmit = () => {
//     const userId = selectedReportingUser || selectedPartner || parentUserId;
//     if (userId) {
//       fetchCityWiseData(userId, fromDate, toDate, filterType);
//     }
//   };

//   // Filter users based on search term
//   const getFilteredUsers = () => {
//     if (!searchTerm.trim()) {
//       return gpcUsers;
//     }
//     return gpcUsers.filter(user =>
//       user.name.toLowerCase().includes(searchTerm.toLowerCase())
//     );
//   };

//   // Filter reporting users based on search term
//   const getFilteredReportingUsers = () => {
//     if (!reportingSearchTerm.trim()) {
//       return reportingUsers;
//     }
//     return reportingUsers.filter(user =>
//       user.name.toLowerCase().includes(reportingSearchTerm.toLowerCase())
//     );
//   };

//   const getStatusCards = () => {
//     if (!apiData || !apiData.cards) return [];
    
//     const cards = apiData.cards;
//     return [
//       { label: "Total Members", value: cards.user_count || 0, color: "#4A90D9" },
//       { label: "Total Leads", value: cards.total_lead || 0, color: "#27AE60" },
//       { label: "Scheduled", value: cards.scheduled || 0, color: "#F39C12" },
//       { label: "F2F Done", value: cards.f2f_count || 0, color: "#8E44AD" },
//       { label: "Site Visit", value: cards.site_visit_count || 0, color: "#1ABC9C" },
//       { label: "Token Done", value: cards.token_done_count || 0, color: "#E67E22" },
//       { label: "Transactions", value: cards.transaction_done_count || 0, color: "#2ECC71" },
//       { label: "Invalid", value: cards.invalid_count || 0, color: "#E74C3C" },
//     ];
//   };

//   const getCityData = () => {
//     if (!apiData) return [];
//     return apiData.city_wise_data || [];
//   };

//   const getValueColor = (value: number) => {
//     if (value >= 25) return "#E74C3C";
//     if (value >= 18) return "#F39C12";
//     if (value >= 10) return "#3498DB";
//     if (value >= 5) return "#27AE60";
//     return "#95A5A6";
//   };

//   const getRowColor = (city: string) => {
//     const colors: { [key: string]: string } = {
//       'Pune': '#E8F5E9',
//       'Mumbai': '#FFF3E0',
//       'Bengaluru': '#E3F2FD',
//       'Dubai': '#FCE4EC',
//       'Global Partners Connect': '#F3E5F5',
//       'Global Property Expo': '#E0F7FA',
//       'Propex': '#FFF8E1',
//       'Home 365': '#F3E5F5',
//     };
//     return colors[city] || '#FFFFFF';
//   };

//   const getRowHoverColor = (city: string) => {
//     const colors: { [key: string]: string } = {
//       'Pune': '#C8E6C9',
//       'Mumbai': '#FFE0B2',
//       'Bengaluru': '#BBDEFB',
//       'Dubai': '#F8BBD0',
//       'Global Partners Connect': '#E1BEE7',
//       'Global Property Expo': '#B2EBF2',
//       'Propex': '#FFECB3',
//       'Home 365': '#E1BEE7',
//     };
//     return colors[city] || '#F5F5F5';
//   };

//   const getRowBorderColor = (city: string) => {
//     const colors: { [key: string]: string } = {
//       'Pune': '#4CAF50',
//       'Mumbai': '#FF9800',
//       'Bengaluru': '#2196F3',
//       'Dubai': '#E91E63',
//       'Global Partners Connect': '#9C27B0',
//       'Global Property Expo': '#00BCD4',
//       'Propex': '#FFC107',
//       'Home 365': '#9C27B0',
//     };
//     return colors[city] || '#DDDDDD';
//   };

//   // Handle city name click to navigate to lead details
//   const handleCityClick = (cityName: string) => {
//     const userId = selectedReportingUser || selectedPartner || parentUserId;
//     if (userId) {
//       const params = new URLSearchParams();
//       params.append('city', cityName);
//       if (filterType) params.append('filter_type', filterType);
//       if (fromDate) params.append('from_date', fromDate);
//       if (toDate) params.append('to_date', toDate);
//       navigate(`/admin-leads/${userId}?${params.toString()}`);
//     }
//   };

//   // Handle value circle click
//   const handleValueClick = (cityName: string, type: string) => {
//     const userId = selectedReportingUser || selectedPartner || parentUserId;
//     if (userId) {
//       const params = new URLSearchParams();
//       params.append('type', type);
//       params.append('city', cityName);
//       if (filterType) params.append('filter_type', filterType);
//       if (fromDate) params.append('from_date', fromDate);
//       if (toDate) params.append('to_date', toDate);
//       navigate(`/admin-leads/${userId}?${params.toString()}`);
//     }
//   };

//   const retryFetch = () => {
//     const userId = selectedReportingUser || selectedPartner || parentUserId;
//     if (userId) {
//       fetchCityWiseData(userId, fromDate, toDate, filterType);
//     } else {
//       fetchGPCUsers();
//     }
//   };

//   const toggleSidebar = () => {
//     setSidebarCollapsed(!sidebarCollapsed);
//   };

//   const isPageLoading = loadingUsers || loading || loadingReportingUsers;

//   // Get current user display name
//   const getCurrentUserDisplay = () => {
//     if (selectedReportingUser) {
//       const user = reportingUsers.find(u => String(u.id) === selectedReportingUser);
//       return user ? user.name : 'Selected User';
//     }
//     if (selectedPartner) {
//       const user = gpcUsers.find(u => String(u.id) === selectedPartner);
//       return user ? user.name : 'Selected Partner';
//     }
//     return 'Parent User';
//   };

//   return (
//     <div className="city-wise-lead-page">
//       <Sidebar />
      
//       <div className={`city-wise-lead-container ${sidebarCollapsed ? 'expanded' : ''}`}>
//         <div className="header-section">
//           <h2>City-wise Leads Overview</h2>
//           <p className="subtitle">
//             {selectedReportingUser 
//               ? `Showing data for reporting user: ${getCurrentUserDisplay()}`
//               : selectedPartner 
//                 ? `Showing data for partner: ${getCurrentUserDisplay()}`
//                 : `Showing overall data for ${getCurrentUserDisplay()} (ID: ${parentUserId})`
//             }
//           </p>
//         </div>

//         {/* Filter Section with Searchable Dropdown and Date Filter */}
//         <div className="filter-section">
//           <div className="filter-row">
//             {/* Partner Dropdown */}
//             <div className="filter-col">
//               <label className="filter-label">Select Partner</label>
//               <div className="searchable-dropdown" ref={dropdownRef}>
//                 <div className="dropdown-input-wrapper">
//                   <input
//                     type="text"
//                     placeholder="Search and select partner..."
//                     value={searchTerm}
//                     onChange={handleSearchChange}
//                     onFocus={() => setIsDropdownOpen(true)}
//                     className="search-input"
//                     disabled={loadingUsers || loading}
//                   />
//                   <span className="dropdown-arrow" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
//                     {isDropdownOpen ? '▲' : '▼'}
//                   </span>
//                 </div>
//                 {isDropdownOpen && (
//                   <div className="dropdown-list">
//                     {loadingUsers ? (
//                       <div className="dropdown-loading">Loading partners...</div>
//                     ) : getFilteredUsers().length > 0 ? (
//                       getFilteredUsers().map((user) => (
//                         <div
//                           key={user.id}
//                           className={`dropdown-item ${selectedPartner === String(user.id) ? 'selected' : ''}`}
//                           onClick={() => handlePartnerSelect(String(user.id), user.name)}
//                         >
//                           <span className="user-name">{user.name}</span>
//                           {selectedPartner === String(user.id) && (
//                             <span className="check-mark">✓</span>
//                           )}
//                         </div>
//                       ))
//                     ) : (
//                       <div className="dropdown-no-results">No partners found</div>
//                     )}
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* Reporting Users Dropdown */}
//             <div className="filter-col">
//               <label className="filter-label">Select Reporting User</label>
//               {loadingReportingUsers ? (
//                 <div className="loading-reporting-users">
//                   <span className="loading-text">Loading reporting users...</span>
//                 </div>
//               ) : reportingUsers.length > 0 ? (
//                 <div className="searchable-dropdown" ref={reportingDropdownRef}>
//                   <div className="dropdown-input-wrapper">
//                     <input
//                       type="text"
//                       placeholder="Search reporting users..."
//                       value={reportingSearchTerm}
//                       onChange={handleReportingSearchChange}
//                       onFocus={() => {
//                         if (reportingUsers.length > 0) {
//                           setIsReportingDropdownOpen(true);
//                         }
//                       }}
//                       className="search-input"
//                       disabled={loadingReportingUsers || loading}
//                     />
//                     <span className="dropdown-arrow" onClick={() => {
//                       if (reportingUsers.length > 0) {
//                         setIsReportingDropdownOpen(!isReportingDropdownOpen);
//                       }
//                     }}>
//                       {isReportingDropdownOpen ? '▲' : '▼'}
//                     </span>
//                   </div>
//                   {isReportingDropdownOpen && (
//                     <div className="dropdown-list">
//                       {getFilteredReportingUsers().length > 0 ? (
//                         getFilteredReportingUsers().map((user) => (
//                           <div
//                             key={user.id}
//                             className={`dropdown-item ${selectedReportingUser === String(user.id) ? 'selected' : ''}`}
//                             onClick={() => handleReportingUserSelect(String(user.id), user.name)}
//                           >
//                             <span className="user-name">{user.name}</span>
//                             {selectedReportingUser === String(user.id) && (
//                               <span className="check-mark">✓</span>
//                             )}
//                           </div>
//                         ))
//                       ) : (
//                         <div className="dropdown-no-results">No reporting users found</div>
//                       )}
//                     </div>
//                   )}
//                 </div>
//               ) : (
//                 <div className="no-reporting-users">
//                   <span className="no-data-text">
//                     {selectedPartner ? 'No reporting users available' : 'Select a partner first'}
//                   </span>
//                 </div>
//               )}
//             </div>

//             {/* Filter Type Column */}
//             <div className="filter-col filter-type-col">
//               <label className="filter-label">Filter Type</label>
//               <div className="filter-type-container">
//                 <select
//                   value={filterType}
//                   onChange={(e) => handleFilterTypeChange(e.target.value as FilterType)}
//                   className="filter-type-select"
//                   disabled={isCustomDate}
//                 >
//                   <option value="overall">Overall</option>
//                   <option value="daily">Daily</option>
//                   <option value="weekly">Weekly</option>
//                   <option value="monthly">Monthly</option>
//                   <option value="quarterly">Quarterly</option>
//                   <option value="yearly">Yearly</option>
//                 </select>
//                 {isCustomDate && (
//                   <span className="custom-badge">Custom</span>
//                 )}
//               </div>
//             </div>

//             {/* Date Filter Column */}
//             <div className="filter-col date-filter-col">
//               <label className="filter-label">Date Range</label>
//               <div className="date-filter-container">
//                 <div className="date-input-group">
//                   <input
//                     type="date"
//                     value={fromDate}
//                     onChange={(e) => {
//                       setFromDate(e.target.value);
//                       setIsCustomDate(true);
//                       setFilterType('overall');
//                     }}
//                     className="date-input"
//                     max={toDate || undefined}
//                   />
//                   <span className="date-separator">-</span>
//                   <input
//                     type="date"
//                     value={toDate}
//                     onChange={(e) => {
//                       setToDate(e.target.value);
//                       setIsCustomDate(true);
//                       setFilterType('overall');
//                     }}
//                     className="date-input"
//                     min={fromDate || undefined}
//                     max={getTodayDate()}
//                   />
//                 </div>
//                 <button
//                   onClick={handleDateFilterSubmit}
//                   className="date-submit-btn"
//                   disabled={loading}
//                 >
//                   {loading ? 'Loading...' : 'Apply'}
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* Active Filter Display */}
//           <div className="active-filter-display">
//             <span className="filter-label-text">Active Filter:</span>
//             <span className="filter-value-badge">
//               {isCustomDate ? 'Custom Date Range' : getFilterTypeLabel(filterType)}
//             </span>
//             {fromDate && toDate && (
//               <span className="filter-date-range">
//                 {fromDate} to {toDate}
//               </span>
//             )}
//             <button 
//               className="clear-filter-btn"
//               onClick={() => {
//                 setFilterType('overall');
//                 setFromDate('');
//                 setToDate('');
//                 setIsCustomDate(false);
//                 const userId = selectedReportingUser || selectedPartner || parentUserId;
//                 if (userId) {
//                   fetchCityWiseData(userId, '', '', 'overall');
//                 }
//               }}
//             >
//               Clear
//             </button>
//           </div>
//         </div>

//         {/* Loading State */}
//         {isPageLoading && (
//           <div className="loading-state">
//             <div className="spinner"></div>
//             <p>{loadingUsers ? "Loading partners..." : loadingReportingUsers ? "Loading reporting users..." : "Loading city-wise data..."}</p>
//           </div>
//         )}

//         {/* Error State */}
//         {error && !isPageLoading && (
//           <div className="error-state">
//             <span className="error-icon">⚠️</span>
//             <h3>Error Loading Data</h3>
//             <p>{error}</p>
//             <button onClick={retryFetch} className="retry-btn">
//               Try Again
//             </button>
//           </div>
//         )}

//         {/* Data Display */}
//         {!isPageLoading && !error && apiData && (
//           <>
//             <div className="summary-section">
//               <h3>Overall Status Summary</h3>
//               <div className="status-cards">
//                 {getStatusCards().map((card, index) => (
//                   <div
//                     key={index}
//                     className="status-card"
//                     style={{ borderLeftColor: card.color }}
//                   >
//                     <span className="status-value">{card.value}</span>
//                     <span className="status-label">{card.label}</span>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             <div className="table-section">
//               <h3>City-wise Leads Distribution</h3>
//               <div className="table-wrapper">
//                 <table className="city-table">
//                   <thead>
//                     <tr>
//                       <th>CITY</th>
//                       <th>TOTAL</th>
//                       <th>ACTIVE</th>
//                       <th>INVALID</th>
//                       <th>NOT Q</th>
//                       <th>SITE V</th>
//                       <th>F2F</th>
//                       <th>SCHED</th>
//                       <th>TOKEN</th>
//                       <th>TRANS</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {getCityData().map((city, index) => (
//                       <tr 
//                         key={index}
//                         className="city-row"
//                         style={{
//                           backgroundColor: getRowColor(city.city),
//                           borderLeft: `4px solid ${getRowBorderColor(city.city)}`
//                         }}
//                         onMouseEnter={(e) => {
//                           e.currentTarget.style.backgroundColor = getRowHoverColor(city.city);
//                         }}
//                         onMouseLeave={(e) => {
//                           e.currentTarget.style.backgroundColor = getRowColor(city.city);
//                         }}
//                       >
//                         <td 
//                           className="city-name clickable"
//                           onClick={() => handleCityClick(city.city)}
//                         >
//                           <span>{city.city}</span>
//                         </td>
//                         <td>
//                           <div 
//                             className="value-circle clickable" 
//                             style={{ backgroundColor: getValueColor(city.total) }}
//                             onClick={() => handleValueClick(city.city, 'total')}
//                           >
//                             {city.total}
//                           </div>
//                         </td>
//                         <td>
//                           <div 
//                             className="value-circle clickable" 
//                             style={{ backgroundColor: getValueColor(city.active) }}
//                             onClick={() => handleValueClick(city.city, 'active')}
//                           >
//                             {city.active}
//                           </div>
//                         </td>
//                         <td>
//                           <div 
//                             className="value-circle clickable" 
//                             style={{ backgroundColor: getValueColor(city.invalid) }}
//                             onClick={() => handleValueClick(city.city, 'invalid')}
//                           >
//                             {city.invalid}
//                           </div>
//                         </td>
//                         <td>
//                           <div 
//                             className="value-circle clickable" 
//                             style={{ backgroundColor: getValueColor(city.not_q) }}
//                             onClick={() => handleValueClick(city.city, 'not_q')}
//                           >
//                             {city.not_q}
//                           </div>
//                         </td>
//                         <td>
//                           <div 
//                             className="value-circle clickable" 
//                             style={{ backgroundColor: getValueColor(city.site_visit) }}
//                             onClick={() => handleValueClick(city.city, 'site_visit')}
//                           >
//                             {city.site_visit}
//                           </div>
//                         </td>
//                         <td>
//                           <div 
//                             className="value-circle clickable" 
//                             style={{ backgroundColor: getValueColor(city.f2f) }}
//                             onClick={() => handleValueClick(city.city, 'f2f')}
//                           >
//                             {city.f2f}
//                           </div>
//                         </td>
//                         <td>
//                           <div 
//                             className="value-circle clickable" 
//                             style={{ backgroundColor: getValueColor(city.scheduled) }}
//                             onClick={() => handleValueClick(city.city, 'scheduled')}
//                           >
//                             {city.scheduled}
//                           </div>
//                         </td>
//                         <td>
//                           <div 
//                             className="value-circle clickable" 
//                             style={{ backgroundColor: getValueColor(city.token_done) }}
//                             onClick={() => handleValueClick(city.city, 'token_done')}
//                           >
//                             {city.token_done}
//                           </div>
//                         </td>
//                         <td>
//                           <div 
//                             className="value-circle clickable" 
//                             style={{ backgroundColor: getValueColor(city.transactions) }}
//                             onClick={() => handleValueClick(city.city, 'transaction')}
//                           >
//                             {city.transactions}
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//               {getCityData().length === 0 && (
//                 <div className="no-data">
//                   <p>No city-wise data available</p>
//                 </div>
//               )}
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default CityWiseLead;
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Sidebar";
import "./CityWiseLead.css";
import API_BASE_URL from "./.././../config/env";

interface CityStats {
  id: number;
  city: string;
  zone: string;
  total: number;
  active: number;
  invalid: number;
  not_q: number;
  site_visit: number;
  f2f: number;
  scheduled: number;
  token_done: number;
  transactions: number;
}

interface CardsData {
  user_count: number;
  total_lead: number;
  scheduled: number;
  f2f_count: number;
  site_visit_count: number;
  token_done_count: number;
  transaction_done_count: number;
  invalid_count: number;
}

interface FiltersData {
  filter_type: string;
  from_date: string | null;
  to_date: string | null;
}

interface ApiResponse {
  status: string;
  filters: FiltersData;
  cards: CardsData;
  city_wise_data: CityStats[];
}

interface GPCUser {
  id: number;
  name: string;
  email: string;
  mobile_number: string | null;
  role_id: number;
  reporting_manager_id: number;
}

interface GPCUsersResponse {
  status: string;
  data: GPCUser[];
  parent_user: number;
  total: number;
  message: string;
}

type FilterType = 'daily' | 'weekly' | 'monthly' | 'quarterly' | 'yearly' | 'overall';

// Get today's date in YYYY-MM-DD format
const getTodayDate = (): string => {
  return new Date().toISOString().split('T')[0];
};

// Get date X days ago
const getDateDaysAgo = (days: number): string => {
  const date = new Date();
  date.setDate(date.getDate() - days);
  return date.toISOString().split('T')[0];
};

// Get date X months ago
const getDateMonthsAgo = (months: number): string => {
  const date = new Date();
  date.setMonth(date.getMonth() - months);
  return date.toISOString().split('T')[0];
};

// Get date X years ago
const getDateYearsAgo = (years: number): string => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - years);
  return date.toISOString().split('T')[0];
};

const CityWiseLead: React.FC = () => {
  const navigate = useNavigate();
  const [selectedPartner, setSelectedPartner] = useState<string>("");
  const [selectedReportingUser, setSelectedReportingUser] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [reportingSearchTerm, setReportingSearchTerm] = useState<string>("");
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const [isReportingDropdownOpen, setIsReportingDropdownOpen] = useState<boolean>(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [apiData, setApiData] = useState<ApiResponse | null>(null);
  const [gpcUsers, setGpcUsers] = useState<GPCUser[]>([]);
  const [reportingUsers, setReportingUsers] = useState<GPCUser[]>([]);
  const [parentUserId, setParentUserId] = useState<string>("");
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [loadingReportingUsers, setLoadingReportingUsers] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const reportingDropdownRef = useRef<HTMLDivElement>(null);
  const token = localStorage.getItem("authToken");

  // Date filter states
  const [filterType, setFilterType] = useState<FilterType>('overall');
  const [fromDate, setFromDate] = useState<string>("");
  const [toDate, setToDate] = useState<string>("");
  const [isCustomDate, setIsCustomDate] = useState<boolean>(false);

  // Get filter type label
  const getFilterTypeLabel = (type: FilterType): string => {
    const labels: Record<FilterType, string> = {
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      quarterly: 'Quarterly',
      yearly: 'Yearly',
      overall: 'Overall'
    };
    return labels[type] || 'Overall';
  };

  // Get date range based on filter type
  const getDateRangeForFilterType = (type: FilterType): { fromDate: string; toDate: string } => {
    const today = getTodayDate();

    switch (type) {
      case 'daily':
        return { fromDate: today, toDate: today };
      case 'weekly':
        return { fromDate: getDateDaysAgo(7), toDate: today };
      case 'monthly':
        return { fromDate: getDateMonthsAgo(1), toDate: today };
      case 'quarterly':
        return { fromDate: getDateMonthsAgo(3), toDate: today };
      case 'yearly':
        return { fromDate: getDateYearsAgo(1), toDate: today };
      case 'overall':
      default:
        return { fromDate: '', toDate: '' };
    }
  };

  // Handle filter type change
  const handleFilterTypeChange = (type: FilterType) => {
    setFilterType(type);
    setIsCustomDate(false);

    if (type === 'overall') {
      setFromDate('');
      setToDate('');
    } else {
      const { fromDate, toDate } = getDateRangeForFilterType(type);
      setFromDate(fromDate);
      setToDate(toDate);
    }

    // Auto-submit when filter type changes
    const userId = selectedReportingUser || selectedPartner || parentUserId;
    if (userId) {
      const { fromDate, toDate } = type === 'overall' 
        ? { fromDate: '', toDate: '' } 
        : getDateRangeForFilterType(type);
      
      setTimeout(() => {
        fetchCityWiseData(userId, fromDate, toDate, type);
      }, 100);
    }
  };

  useEffect(() => {
    // Set default filter to overall
    setFilterType('overall');
    setFromDate('');
    setToDate('');

    // Fetch GPC users and parent_user
    fetchGPCUsers();
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close reporting dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (reportingDropdownRef.current && !reportingDropdownRef.current.contains(event.target as Node)) {
        setIsReportingDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Fetch city-wise data with user_id parameter, date filters, and filter type
  const fetchCityWiseData = async (
    userId: string, 
    fromDateParam?: string, 
    toDateParam?: string,
    filterTypeParam?: FilterType
  ) => {
    if (!userId) {
      console.warn("No user ID provided");
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    // Build URL with query parameters
    let url = `${API_BASE_URL}/api/partner-count/leads/city-wise-data/${userId}`;
    const params = new URLSearchParams();
    
    // Add filter type if provided
    if (filterTypeParam) {
      params.append('filter_type', filterTypeParam);
    }
    
    // Add date filters if provided
    if (fromDateParam) {
      params.append('from_date', fromDateParam);
    }
    if (toDateParam) {
      params.append('to_date', toDateParam);
    }
    
    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    try {
      console.log("Fetching city-wise data from:", url);

      const response = await axios.get(
        url,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json",
          },
          timeout: 30000,
        }
      );

      console.log("API Response:", response.data);

      if (response.data.status === "success") {
        setApiData(response.data);
      } else {
        setError(response.data.message || "Failed to fetch data");
      }
    } catch (err: any) {
      console.error("Error fetching city-wise data:", err);
      
      let errorMessage = "Failed to fetch city-wise data";
      
      if (err.response) {
        if (err.response.status === 404) {
          errorMessage = `API endpoint not found. Please check the URL: ${url}`;
        } else if (err.response.status === 401) {
          errorMessage = "Unauthorized. Please login again.";
        } else if (err.response.status === 403) {
          errorMessage = "You don't have permission to access this data.";
        } else {
          errorMessage = err.response.data?.message || err.response.data?.error || errorMessage;
        }
      } else if (err.request) {
        errorMessage = "No response from server. Please check your internet connection.";
      } else {
        errorMessage = err.message || errorMessage;
      }
      
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const fetchGPCUsers = async () => {
    if (!token) {
      console.warn("No token found for fetching GPC users");
      setError("User not authenticated. Please login again.");
      setLoading(false);
      return;
    }

    setLoadingUsers(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/partner-count/gpc-users-over-target`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json",
          },
          timeout: 15000,
        }
      );

      console.log("GPC Users Response:", response.data);

      if (response.data.status === "success" && response.data.data) {
        const users = response.data.data;
        const parentUser = response.data.parent_user || 1161;
        
        setGpcUsers(users);
        setParentUserId(String(parentUser));
        
        console.log("Parent User ID:", parentUser);
        console.log("Total Users:", users.length);
        
        // Set search term to empty (no pre-selection)
        setSearchTerm('');
        
        // Fetch reporting users for parent_user
        await fetchReportingUsers(String(parentUser));
        
        // Fetch overall data for parent_user
        fetchCityWiseData(String(parentUser), '', '', 'overall');
      } else {
        console.warn("Failed to fetch GPC users:", response.data.message);
        setError(response.data.message || "Failed to fetch users");
        setLoading(false);
      }
    } catch (err: any) {
      console.error("Error fetching GPC users:", err);
      
      let errorMessage = "Failed to fetch users";
      if (err.response) {
        errorMessage = err.response.data?.message || err.response.data?.error || errorMessage;
        if (err.response.status === 401) {
          errorMessage = "Unauthorized. Please login again.";
        }
      } else if (err.request) {
        errorMessage = "No response from server. Please check your internet connection.";
      }
      setError(errorMessage);
      setLoading(false);
    } finally {
      setLoadingUsers(false);
    }
  };

  // Fetch reporting users for selected partner or parent_user
  const fetchReportingUsers = async (userId: string) => {
    if (!userId) {
      console.warn("No user ID provided for fetching reporting users");
      setReportingUsers([]);
      setSelectedReportingUser("");
      setReportingSearchTerm("");
      return;
    }

    console.log("Fetching reporting users for targetUserId:", userId);
    setLoadingReportingUsers(true);
    
    try {
      const url = `${API_BASE_URL}/api/partner-count/gpc-users-over-target?targetUserId=${userId}`;
      console.log("Fetching reporting users from:", url);

      const response = await axios.get(
        url,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json",
          },
          timeout: 15000,
        }
      );

      console.log("Reporting Users Response Data:", response.data);

      if (response.data.status === "success" && response.data.data && response.data.data.length > 0) {
        console.log(`Found ${response.data.data.length} reporting users`);
        console.log("Reporting Users List:", response.data.data);
        
        const users = response.data.data;
        setReportingUsers(users);
        // Do NOT pre-select any reporting user
        setSelectedReportingUser("");
        setReportingSearchTerm("");
      } else {
        console.log("No reporting users found for this user");
        setReportingUsers([]);
        setSelectedReportingUser("");
        setReportingSearchTerm("");
      }
    } catch (err: any) {
      console.error("Error fetching reporting users:", err);
      
      let errorMessage = "Failed to fetch reporting users";
      
      if (err.response) {
        if (err.response.status === 404) {
          errorMessage = "API endpoint not found. Please check the URL.";
        } else if (err.response.status === 401) {
          errorMessage = "Unauthorized. Please login again.";
        } else if (err.response.status === 403) {
          errorMessage = "You don't have permission to access this data.";
        } else if (err.response.status === 500) {
          errorMessage = "Server error. Please try again later.";
        } else {
          errorMessage = err.response.data?.message || errorMessage;
        }
      } else if (err.message && err.message.includes('CORS')) {
        errorMessage = "CORS error: Please contact administrator to enable CORS for this API.";
      } else if (err.request) {
        errorMessage = "No response from server. Please check your internet connection.";
      } else {
        errorMessage = err.message || errorMessage;
      }
      
      setError(errorMessage);
      setReportingUsers([]);
      setSelectedReportingUser("");
      setReportingSearchTerm("");
    } finally {
      setLoadingReportingUsers(false);
    }
  };

  // Handle partner selection
  const handlePartnerSelect = (userId: string, userName: string) => {
    console.log("Partner selected with ID:", userId, "Name:", userName);
    setSelectedPartner(userId);
    setSearchTerm(userName);
    setIsDropdownOpen(false);
    
    // Reset reporting users
    setReportingUsers([]);
    setSelectedReportingUser("");
    setReportingSearchTerm("");
    
    // Fetch reporting users for the selected partner
    fetchReportingUsers(userId);
    
    // Fetch data for selected partner with current filter
    fetchCityWiseData(userId, fromDate, toDate, filterType);
  };

  // Handle reporting user selection
  const handleReportingUserSelect = (userId: string, userName: string) => {
    console.log("Reporting user selected:", userId, userName);
    setSelectedReportingUser(userId);
    setReportingSearchTerm(userName);
    setIsReportingDropdownOpen(false);
    // Fetch city-wise data with the selected reporting user
    fetchCityWiseData(userId, fromDate, toDate, filterType);
  };

  // Handle search input change
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
    setIsDropdownOpen(true);
    // If search is cleared, reset selection
    if (!e.target.value.trim()) {
      setSelectedPartner("");
      // Reset reporting users
      setReportingUsers([]);
      setSelectedReportingUser("");
      setReportingSearchTerm("");
      // Show parent_user data again
      if (parentUserId) {
        fetchCityWiseData(parentUserId, fromDate, toDate, filterType);
        // Also fetch reporting users for parent_user
        fetchReportingUsers(parentUserId);
      }
    }
  };

  // Handle reporting search input change
  const handleReportingSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setReportingSearchTerm(e.target.value);
    setIsReportingDropdownOpen(true);
    // If search is cleared, reset selection
    if (!e.target.value.trim()) {
      setSelectedReportingUser("");
    }
  };

  // Handle date filter submit
  const handleDateFilterSubmit = () => {
    const userId = selectedReportingUser || selectedPartner || parentUserId;
    if (userId) {
      fetchCityWiseData(userId, fromDate, toDate, filterType);
    }
  };

  // Filter users based on search term
  const getFilteredUsers = () => {
    if (!searchTerm.trim()) {
      return gpcUsers;
    }
    return gpcUsers.filter(user =>
      user.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  // Filter reporting users based on search term
  const getFilteredReportingUsers = () => {
    if (!reportingSearchTerm.trim()) {
      return reportingUsers;
    }
    return reportingUsers.filter(user =>
      user.name.toLowerCase().includes(reportingSearchTerm.toLowerCase())
    );
  };

  const getStatusCards = () => {
    if (!apiData || !apiData.cards) return [];
    
    const cards = apiData.cards;
    return [
      { label: "Total Members", value: cards.user_count || 0, color: "#4A90D9" },
      { label: "Total Leads", value: cards.total_lead || 0, color: "#27AE60" },
      { label: "Scheduled", value: cards.scheduled || 0, color: "#F39C12" },
      { label: "F2F Done", value: cards.f2f_count || 0, color: "#8E44AD" },
      { label: "Site Visit", value: cards.site_visit_count || 0, color: "#1ABC9C" },
      { label: "Token Done", value: cards.token_done_count || 0, color: "#E67E22" },
      { label: "Transactions", value: cards.transaction_done_count || 0, color: "#2ECC71" },
      { label: "Invalid", value: cards.invalid_count || 0, color: "#E74C3C" },
    ];
  };

  const getCityData = () => {
    if (!apiData) return [];
    return apiData.city_wise_data || [];
  };

  const getValueColor = (value: number) => {
    if (value >= 25) return "#E74C3C";
    if (value >= 18) return "#F39C12";
    if (value >= 10) return "#3498DB";
    if (value >= 5) return "#27AE60";
    return "#95A5A6";
  };

  const getRowColor = (city: string) => {
    const colors: { [key: string]: string } = {
      'Pune': '#E8F5E9',
      'Mumbai': '#FFF3E0',
      'Bengaluru': '#E3F2FD',
      'Dubai': '#FCE4EC',
      'Global Partners Connect': '#F3E5F5',
      'Global Property Expo': '#E0F7FA',
      'Propex': '#FFF8E1',
      'Home 365': '#F3E5F5',
    };
    return colors[city] || '#FFFFFF';
  };

  const getRowHoverColor = (city: string) => {
    const colors: { [key: string]: string } = {
      'Pune': '#C8E6C9',
      'Mumbai': '#FFE0B2',
      'Bengaluru': '#BBDEFB',
      'Dubai': '#F8BBD0',
      'Global Partners Connect': '#E1BEE7',
      'Global Property Expo': '#B2EBF2',
      'Propex': '#FFECB3',
      'Home 365': '#E1BEE7',
    };
    return colors[city] || '#F5F5F5';
  };

  const getRowBorderColor = (city: string) => {
    const colors: { [key: string]: string } = {
      'Pune': '#4CAF50',
      'Mumbai': '#FF9800',
      'Bengaluru': '#2196F3',
      'Dubai': '#E91E63',
      'Global Partners Connect': '#9C27B0',
      'Global Property Expo': '#00BCD4',
      'Propex': '#FFC107',
      'Home 365': '#9C27B0',
    };
    return colors[city] || '#DDDDDD';
  };

  // Handle city name click to navigate to lead details
  const handleCityClick = (cityName: string) => {
    const userId = selectedReportingUser || selectedPartner || parentUserId;
    if (userId) {
      const params = new URLSearchParams();
      params.append('city', cityName);
      if (filterType) params.append('filter_type', filterType);
      if (fromDate) params.append('from_date', fromDate);
      if (toDate) params.append('to_date', toDate);
      navigate(`/admin-leads/${userId}?${params.toString()}`);
    }
  };

  // Handle value circle click
  const handleValueClick = (cityName: string, type: string) => {
    const userId = selectedReportingUser || selectedPartner || parentUserId;
    if (userId) {
      const params = new URLSearchParams();
      params.append('type', type);
      params.append('city', cityName);
      if (filterType) params.append('filter_type', filterType);
      if (fromDate) params.append('from_date', fromDate);
      if (toDate) params.append('to_date', toDate);
      navigate(`/admin-leads/${userId}?${params.toString()}`);
    }
  };

  const retryFetch = () => {
    const userId = selectedReportingUser || selectedPartner || parentUserId;
    if (userId) {
      fetchCityWiseData(userId, fromDate, toDate, filterType);
    } else {
      fetchGPCUsers();
    }
  };

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const isPageLoading = loadingUsers || loading || loadingReportingUsers;

  // Get current user display name
  const getCurrentUserDisplay = () => {
    if (selectedReportingUser) {
      const user = reportingUsers.find(u => String(u.id) === selectedReportingUser);
      return user ? user.name : 'Selected User';
    }
    if (selectedPartner) {
      const user = gpcUsers.find(u => String(u.id) === selectedPartner);
      return user ? user.name : 'Selected Partner';
    }
    return 'Parent User';
  };

  return (
    <div className="city-wise-lead-page">
      <Sidebar />
      
      <div className={`city-wise-lead-container ${sidebarCollapsed ? 'expanded' : ''}`}>
        <div className="header-section">
          <h2>City-wise Leads Overview</h2>
          <p className="subtitle">
            {selectedReportingUser 
              ? `Showing data for reporting user: ${getCurrentUserDisplay()}`
              : selectedPartner 
                ? `Showing data for partner: ${getCurrentUserDisplay()}`
                : `Showing overall data for ${getCurrentUserDisplay()} (ID: ${parentUserId})`
            }
          </p>
        </div>

        {/* Filter Section - All in Single Row */}
        <div className="filter-section">
          <div className="filter-row">
            {/* Partner Dropdown */}
            <div className="filter-col filter-col-partner">
              <label className="filter-label">Select Partner</label>
              <div className="searchable-dropdown" ref={dropdownRef}>
                <div className="dropdown-input-wrapper">
                  <input
                    type="text"
                    placeholder="Search partner..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                    onFocus={() => setIsDropdownOpen(true)}
                    className="search-input"
                    disabled={loadingUsers || loading}
                  />
                  <span className="dropdown-arrow" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                    {isDropdownOpen ? '▲' : '▼'}
                  </span>
                </div>
                {isDropdownOpen && (
                  <div className="dropdown-list">
                    {loadingUsers ? (
                      <div className="dropdown-loading">Loading partners...</div>
                    ) : getFilteredUsers().length > 0 ? (
                      getFilteredUsers().map((user) => (
                        <div
                          key={user.id}
                          className={`dropdown-item ${selectedPartner === String(user.id) ? 'selected' : ''}`}
                          onClick={() => handlePartnerSelect(String(user.id), user.name)}
                        >
                          <span className="user-name">{user.name}</span>
                          {selectedPartner === String(user.id) && (
                            <span className="check-mark">✓</span>
                          )}
                        </div>
                      ))
                    ) : (
                      <div className="dropdown-no-results">No partners found</div>
                    )}
                  </div>
                )}
              </div>
            </div>

            {/* Reporting Users Dropdown */}
            <div className="filter-col filter-col-reporting">
              <label className="filter-label">Select Reporting User</label>
              {loadingReportingUsers ? (
                <div className="loading-reporting-users">
                  <span className="loading-text">Loading...</span>
                </div>
              ) : reportingUsers.length > 0 ? (
                <div className="searchable-dropdown" ref={reportingDropdownRef}>
                  <div className="dropdown-input-wrapper">
                    <input
                      type="text"
                      placeholder="Search reporting..."
                      value={reportingSearchTerm}
                      onChange={handleReportingSearchChange}
                      onFocus={() => {
                        if (reportingUsers.length > 0) {
                          setIsReportingDropdownOpen(true);
                        }
                      }}
                      className="search-input"
                      disabled={loadingReportingUsers || loading}
                    />
                    <span className="dropdown-arrow" onClick={() => {
                      if (reportingUsers.length > 0) {
                        setIsReportingDropdownOpen(!isReportingDropdownOpen);
                      }
                    }}>
                      {isReportingDropdownOpen ? '▲' : '▼'}
                    </span>
                  </div>
                  {isReportingDropdownOpen && (
                    <div className="dropdown-list">
                      {getFilteredReportingUsers().length > 0 ? (
                        getFilteredReportingUsers().map((user) => (
                          <div
                            key={user.id}
                            className={`dropdown-item ${selectedReportingUser === String(user.id) ? 'selected' : ''}`}
                            onClick={() => handleReportingUserSelect(String(user.id), user.name)}
                          >
                            <span className="user-name">{user.name}</span>
                            {selectedReportingUser === String(user.id) && (
                              <span className="check-mark">✓</span>
                            )}
                          </div>
                        ))
                      ) : (
                        <div className="dropdown-no-results">No reporting users found</div>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                <div className="no-reporting-users">
                  <span className="no-data-text">
                    {selectedPartner ? 'No reporting users' : 'Select partner first'}
                  </span>
                </div>
              )}
            </div>

            {/* Filter Type */}
            <div className="filter-col filter-col-type">
              <label className="filter-label">Filter Type</label>
              <div className="filter-type-container">
                <select
                  value={filterType}
                  onChange={(e) => handleFilterTypeChange(e.target.value as FilterType)}
                  className="filter-type-select"
                  disabled={isCustomDate}
                >
                  <option value="overall">Overall</option>
                  <option value="daily">Daily</option>
                  <option value="weekly">Weekly</option>
                  <option value="monthly">Monthly</option>
                  <option value="quarterly">Quarterly</option>
                  <option value="yearly">Yearly</option>
                </select>
                {isCustomDate && <span className="custom-badge">Custom</span>}
              </div>
            </div>

            {/* Date Range */}
            <div className="filter-col filter-col-date">
              <label className="filter-label">Date Range</label>
              <div className="date-filter-container">
                <div className="date-input-group">
                  <input
                    type="date"
                    value={fromDate}
                    onChange={(e) => {
                      setFromDate(e.target.value);
                      setIsCustomDate(true);
                      setFilterType('overall');
                    }}
                    className="date-input"
                    max={toDate || undefined}
                  />
                  <span className="date-separator">-</span>
                  <input
                    type="date"
                    value={toDate}
                    onChange={(e) => {
                      setToDate(e.target.value);
                      setIsCustomDate(true);
                      setFilterType('overall');
                    }}
                    className="date-input"
                    min={fromDate || undefined}
                    max={getTodayDate()}
                  />
                </div>
                <button
                  onClick={handleDateFilterSubmit}
                  className="date-submit-btn"
                  disabled={loading}
                >
                  {loading ? 'Loading...' : 'Apply'}
                </button>
              </div>
            </div>
          </div>

          {/* Active Filter Display */}
          <div className="active-filter-display">
            <span className="filter-label-text">Active Filter:</span>
            <span className="filter-value-badge">
              {isCustomDate ? 'Custom Date Range' : getFilterTypeLabel(filterType)}
            </span>
            {fromDate && toDate && (
              <span className="filter-date-range">
                {fromDate} to {toDate}
              </span>
            )}
            <button 
              className="clear-filter-btn"
              onClick={() => {
                setFilterType('overall');
                setFromDate('');
                setToDate('');
                setIsCustomDate(false);
                const userId = selectedReportingUser || selectedPartner || parentUserId;
                if (userId) {
                  fetchCityWiseData(userId, '', '', 'overall');
                }
              }}
            >
              Clear
            </button>
          </div>
        </div>

        {/* Loading State */}
        {isPageLoading && (
          <div className="loading-state">
            <div className="spinner"></div>
            <p>{loadingUsers ? "Loading partners..." : loadingReportingUsers ? "Loading reporting users..." : "Loading city-wise data..."}</p>
          </div>
        )}

        {/* Error State */}
        {error && !isPageLoading && (
          <div className="error-state">
            <span className="error-icon">⚠️</span>
            <h3>Error Loading Data</h3>
            <p>{error}</p>
            <button onClick={retryFetch} className="retry-btn">
              Try Again
            </button>
          </div>
        )}

        {/* Data Display */}
        {!isPageLoading && !error && apiData && (
          <>
            <div className="summary-section">
              <h3>Overall Status Summary</h3>
              <div className="status-cards">
                {getStatusCards().map((card, index) => (
                  <div
                    key={index}
                    className="status-card"
                    style={{ borderLeftColor: card.color }}
                  >
                    <span className="status-value">{card.value}</span>
                    <span className="status-label">{card.label}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="table-section">
              <h3>City-wise Leads Distribution</h3>
              <div className="table-wrapper">
                <table className="city-table">
                  <thead>
                    <tr>
                      <th>CITY</th>
                      <th>TOTAL</th>
                      <th>ACTIVE</th>
                      <th>INVALID</th>
                      <th>NOT Q</th>
                      <th>SITE V</th>
                      <th>F2F</th>
                      <th>SCHED</th>
                      <th>TOKEN</th>
                      <th>TRANS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getCityData().map((city, index) => (
                      <tr 
                        key={index}
                        className="city-row"
                        style={{
                          backgroundColor: getRowColor(city.city),
                          borderLeft: `4px solid ${getRowBorderColor(city.city)}`
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = getRowHoverColor(city.city);
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = getRowColor(city.city);
                        }}
                      >
                        <td 
                          className="city-name clickable"
                          onClick={() => handleCityClick(city.city)}
                        >
                          <span>{city.city}</span>
                        </td>
                        <td>
                          <div 
                            className="value-circle clickable" 
                            style={{ backgroundColor: getValueColor(city.total) }}
                            onClick={() => handleValueClick(city.city, 'total')}
                          >
                            {city.total}
                          </div>
                        </td>
                        <td>
                          <div 
                            className="value-circle clickable" 
                            style={{ backgroundColor: getValueColor(city.active) }}
                            onClick={() => handleValueClick(city.city, 'active')}
                          >
                            {city.active}
                          </div>
                        </td>
                        <td>
                          <div 
                            className="value-circle clickable" 
                            style={{ backgroundColor: getValueColor(city.invalid) }}
                            onClick={() => handleValueClick(city.city, 'invalid')}
                          >
                            {city.invalid}
                          </div>
                        </td>
                        <td>
                          <div 
                            className="value-circle clickable" 
                            style={{ backgroundColor: getValueColor(city.not_q) }}
                            onClick={() => handleValueClick(city.city, 'not_q')}
                          >
                            {city.not_q}
                          </div>
                        </td>
                        <td>
                          <div 
                            className="value-circle clickable" 
                            style={{ backgroundColor: getValueColor(city.site_visit) }}
                            onClick={() => handleValueClick(city.city, 'site_visit')}
                          >
                            {city.site_visit}
                          </div>
                        </td>
                        <td>
                          <div 
                            className="value-circle clickable" 
                            style={{ backgroundColor: getValueColor(city.f2f) }}
                            onClick={() => handleValueClick(city.city, 'f2f')}
                          >
                            {city.f2f}
                          </div>
                        </td>
                        <td>
                          <div 
                            className="value-circle clickable" 
                            style={{ backgroundColor: getValueColor(city.scheduled) }}
                            onClick={() => handleValueClick(city.city, 'scheduled')}
                          >
                            {city.scheduled}
                          </div>
                        </td>
                        <td>
                          <div 
                            className="value-circle clickable" 
                            style={{ backgroundColor: getValueColor(city.token_done) }}
                            onClick={() => handleValueClick(city.city, 'token_done')}
                          >
                            {city.token_done}
                          </div>
                        </td>
                        <td>
                          <div 
                            className="value-circle clickable" 
                            style={{ backgroundColor: getValueColor(city.transactions) }}
                            onClick={() => handleValueClick(city.city, 'transaction')}
                          >
                            {city.transactions}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {getCityData().length === 0 && (
                <div className="no-data">
                  <p>No city-wise data available</p>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CityWiseLead;